<template>
  <Content id="roles">
    <div slot="search">
      <Search :model="search" :elem="searchElem" :btn-loading="list.loading" @on-search="handleDataList" />
    </div>
    <!-- Search -->
    <div slot="extra">
      <Button icon="md-add" @click="handleCreate" type="primary">添加</Button>
    </div>

    <Table stripe :columns="columns" :data="list.data" ref="list"
           highlight-row
           :row-class-name="tableRowClassName"
           @on-selection-change="handleSelectionChange">
      <template slot-scope="{row}" slot="operation">
          <a @click.stop="handleUser(row)" v-if="userType <= 3">用户</a>&nbsp;&nbsp;
          <a @click.stop="handleEdit(row)"><i class="ivu-icon ivu-icon-md-create" style="font-size: 16px; margin-top: -2px; margin-right: 2px;"></i>编辑</a>&nbsp;&nbsp;
          <a @click.stop="handleRemove(row)"><i class="ivu-icon ivu-icon-md-trash" style="font-size: 16px; margin-top: -2px; margin-right: 2px;"></i>删除</a>
      </template>
    </Table>

    <Page class="page" placement="top"
          show-total show-elevator show-sizer :total="list.total"
          :current="pageList.currentPage" :page-size="pageList.pageSize"
          :page-size-opts="[10, 20, 50, 100, 200]"
          @on-change="chagecurrent" @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <!-- ITable -->
    <RoleEdit ref="edit" @on-update="handleDataList" />
    <!-- UserEdit -->

    <Modal v-model="userWindow" width="60%" :title="windowTitle">
      <usersManage ref="user"/>
      <div slot="footer"></div>
    </Modal>

  </Content>
</template>
<script>
import {
  _delRole, // 删除
  _getRoleList // 列表
} from "@/services/manage/roles";
import RoleEdit from "./RolesEdit";
import usersManage from "./Users.vue"
export default {
  name: "Roles",
  components: {
    RoleEdit,
    usersManage
  },
  data() {
    return {
      // 表单数据
      search: {
        name: ""
      },
      userType : null,
      userWindow:false,
      windowTitle:"用户列表",
      // 列表属性
      list: {
        data: [], // 结构化数据
        total: 0, // 数据总数
        loading: false // 加载状态
      },
      pageList:{
        currentPage:1,
        pageSize:10,
      },
      // 表单元素
      searchElem: [
        {
          label: '角色名',
          prop: "name",
          labelWidth: 80,
          placeholder: "请输入角色名称",
        },
        {
          label: '状态',
          prop: "status",
          labelWidth: 50,
          element: 'select',
          option: [
            {label: '全部', value: ''},
            {label: '启用', value: 1},
            {label: '禁用', value: 2},
          ]
        },
      ],
      // 表格列的配置描述
      columns: [
        {
          title: "角色名",
          key: "name",
          minWidth: 150
        },
        {
          title: "上级",
          key: "parentName",
          minWidth: 150
        },
         {
          title: "操作人",
          key: "operator",
          minWidth: 80
        }, {
          title: "创建时间",
          key: "createTime",
          minWidth: 100
        }, {
          title: "状态",
          key: "status",
          minWidth: 80,
          render: (h, params) =>
            h('span', params.row.status === 1 ? "启用" : "禁用")
        },
        {
          title: "操作",
          align: "center",
          fixed: "right",
          minWidth: 200,
          slot: 'operation',
        }
      ]
    };
  },
  mounted() {

    this.userType = this.$userSession.getUserType();

    this.handleDataList(true); // 获取列表数据
    if(this.userType < 3){
      this.columns = [
        {
          title: "角色名",
          key: "name",
          minWidth: 150
        },
        {
          title: "级别",
          key: "level",
          minWidth: 100,
          render:(h,params)=>h('span',this.convertLevel(params))
        },
        {
          title: "上级",
          key: "parentName",
          minWidth: 150
        },
        {
          title: "操作人",
          key: "operator",
          minWidth: 80
        }, {
          title: "创建时间",
          key: "createTime",
          minWidth: 100
        }, {
          title: "状态",
          key: "status",
          minWidth: 80,
          render: (h, params) =>
              h('span', params.row.status === 1 ? "启用" : "禁用")
        },
        {
          title: "操作",
          align: "center",
          fixed: "right",
          minWidth: 200,
          slot: 'operation',
        }
      ]
    }
  },
  methods: {
    convertLevel(params){
      if (params.row.level == 1){
        return "超级管理员";
      }else if (params.row.level == 2) {
        return "全国级管理员";
      }else if (params.row.level == 3) {
        return "省级管理员";
      }else if (params.row.level == 4) {
        return "市级管理员";
      }else if (params.row.level == 5) {
        return "区级管理员";
      }else if (params.row.level == 6) {
        return "街道管理员";
      }else if (params.row.level == 7) {
        return "普通角色";
      }else{
        return "";
      }
    },
    /**
     * @param  {string} type 是否使用搜索, 默认值 undefined (不使用搜索)
     */
    handleDataList(type) {

      this.$Loading.start();
      this.list.loading = true; // 列表加载状态

      this.pageList.currentPage = type ? 1 : this.pageList.currentPage;
      // 模拟异步请求(搜索)
        _getRoleList({
          ...this.search,
          currentPage: this.pageList.currentPage,
          pageSize: this.pageList.pageSize
        }).then(res => {
            this.$Loading.finish();
            const { records, total} = res.data;
            this.list = {
              data: records,
              total: parseInt(total),
              loading: false
            };
          }).catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
    },
    // 新增界面
    handleCreate() {
      this.$refs["edit"].handleModal(true,"新增角色"); // 显示创建模态框
    },
    /**
     * 用户界面
     * @param  {object} row 当前行数据
     */
    handleUser(row) {
      this.windowTitle = row.name;
      this.userWindow = true;
      this.$refs["user"].openWindow(row.name, row);
    },
    /**
     * 编辑界面
     * @param  {object} row 当前行数据
     */
    handleEdit(row) {
      this.$refs["edit"].handleModal(false,"角色编辑", row); // 显示编辑模态框
    },
    /**
     * 删除用户
     * @param  {object} row 当前行数据
     */
    handleRemove(row) {
      this.$Loading.start();
      this.list.loading = true;
      // 模拟异步请求(删除)
      setTimeout(() => {
        _delRole({
          id: row.id
        })
          .then(res => {
            this.$message.success(res.errmsg);
            this.handleDataList();
          })
          .catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
      }, 500);
    },
    tableRowClassName(row, rowIndex) {
      row.index = rowIndex;
      if (this.currentRowIndex === rowIndex) {
        return "success-row";
      }
    },
    /**
     * 在多选模式下有效，只要选中项发生变化时就会触发
     * @param  {array} selection 已选项数据
     */
    handleSelectionChange(selection) {
      const ids = [];
      for (const item of selection) {
        ids.push(item["id"]);
      }
      this.toolbar = {
        ids: ids,
        number: selection.length
      };
    },
    chagecurrent(e){
      this.pageList.currentPage=e
      this.handleDataList();
    },
    chagepagesize(e){
      this.pageList.pageSize=e
      this.handleDataList();
    },
  },
};
</script>
<style lang="postcss" scoped>
.toolbar {
  margin-bottom: 24px;
  text-align: right;

  & .number {
    margin-right: 8px;
  }
}
</style>
